import { atom } from '@exodus/jotai';
import stringify from 'fast-json-stable-stringify';
import { isPlainObject } from '@exodus/basic-utils';
import lodash from 'lodash';
export const exodusAtom = atom(null);
export const adaptersAtom = atom(null);
const reduxStateAtom = atom({});
export const reduxAtom = atom(null);
reduxAtom.unstable_onInit = (store) => {
    store.sub(reduxAtom, () => {
        const reduxStore = store.get(reduxAtom);
        if (!reduxStore)
            return;
        const callback = () => {
            store.set(reduxStateAtom, reduxStore.getState());
        };
        reduxStore.subscribe(callback);
        callback();
    });
};
export const selectorsAtom = atom({});
const wrapSelector = (selector) => {
    const cache = new Map();
    const baseAtom = atom((get) => {
        const reduxState = get(reduxStateAtom);
        return selector(reduxState);
    });
    return new Proxy(() => { }, {
        apply(_target, _thisArg, args) {
            const key = stringify(args);
            if (!cache.has(key)) {
                const selectorFactory = selector;
                const result = wrapSelector(selectorFactory(...args));
                cache.set(key, result);
                return result;
            }
            return cache.get(key);
        },
        get(_target, prop) {
            return baseAtom[prop];
        },
    });
};
const wrapSelectors = (obj, fn) => {
    return lodash.cloneDeepWith(obj, (value) => {
        if (!isPlainObject(value) && !Array.isArray(value)) {
            return fn(value);
        }
    });
};
export const selectorsAtomsAtoms = atom((get) => {
    const selectors = get(selectorsAtom);
    return wrapSelectors(selectors, wrapSelector);
});
